import { UiTooltipModel } from "../../models";

import { mockAdfDocument } from "./mock-adf-doc";

export function mockUiTooltipModel({
    id = "tooltip-1234",
    type = "uiTooltip",
    locale = "en",
    content = mockUiTooltipModelContent()
}: Partial<UiTooltipModel> = {}): UiTooltipModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTooltipModelContent = UiTooltipModel["content"];

export function mockUiTooltipModelContent({
    triggerText = "Example tooltip",
    tooltipText = mockAdfDocument()
}: Partial<UiTooltipModelContent> = {}): UiTooltipModelContent {
    return {
        triggerText,
        tooltipText
    };
}
